export default __webpack_public_path__ + "static/media/arangodb.e7246942.svg";